import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { Form, Text, Select } from 'react-form';
import { api } from '@src/services/api';
import { checkLevel, isLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { Switch } from "@src/services/form";
import {isReadOnly} from 'services/user';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { SettingsDepartment as Edit, Box } from '@src/components';

// typing
interface LocalProps extends PropsList {
    
}
interface LocalState extends StateList {
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Department extends ProtoList<LocalProps, LocalState> {
    
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { cpt, urlShow, urlCreate, urlUpdate } = this.props;
        const { loading, action, editing, data, search = {}, items = [], tableProps, editProps } = this.state;
        
        const columns = [
            { ...defaultProps.columns.id },
            { Header: _('col_customer', 'SettingsDepartment'), accessor: 'customer.name' },
            { Header: _('col_description', 'SettingsDepartment'), accessor: 'description' },
        ];
        
        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;
        
        let localEditProps = {
            ...editProps
        } as any;
        if (action === "EDIT") {
            localEditProps.id = editing;
        }

		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('list_title', 'SettingsDepartment')}
                toolbar={!isLevel('customer') ? (!isReadOnly()?this.Toolbar:null): null}
                collapsed={false}
            >
                <div className={style}>
                    <Form onSubmit={(v) => this.search(v)}>
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsDepartment')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                            </div>
                            <footer>
                                <span />
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_search`, 'Settings')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Box>
            
            <ReactTable
                {...localTableProps}
                data={items}
                columns={columns}
            />

            </>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/List/Department.tsx